module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_M5-f68e326d72e73827299b2f673b79c716.webp";